export const actionTypes = {
  LOAD_TASK_BADGE: "LOAD_TASK_BADGE",
  LOAD_TASK_BADGE_SUCCESS: "LOAD_TASK_BADGE_SUCCESS",
  LOAD_TASK_BADGE_FAILURE: "LOAD_TASK_BADGE_FAILURE",
  LOAD_APPROVAL_BADGE: "LOAD_APPROVAL_BADGE",
  LOAD_APPROVAL_BADGE_SUCCESS: "LOAD_APPROVAL_BADGE_SUCCESS",
  LOAD_APPROVAL_BADGE_FAILURE: "LOAD_APPROVAL_BADGE_FAILURE",
  LOAD_NOTIFY: "LOAD_NOTIFY",
  LOAD_NOTIFY_SUCCESS: "LOAD_NOTIFY_SUCCESS",
  LOAD_NOTIFY_FAILURE: "LOAD_NOTIFY_FAILURE",
};

export const loadTaskBadge = () => ({
  type: actionTypes.LOAD_TASK_BADGE,
});

export const loadTaskBadgeSuccess = (numTask: number) => ({
  type: actionTypes.LOAD_TASK_BADGE_SUCCESS,
  payload: numTask,
});

export const loadTaskBadgeFailure = (err: Error) => ({
  type: actionTypes.LOAD_TASK_BADGE_FAILURE,
  err,
});

export const loadApprovalBadge = () => ({
  type: actionTypes.LOAD_APPROVAL_BADGE,
});

export const loadApprovalBadgeSuccess = (numApproval: number) => ({
  type: actionTypes.LOAD_APPROVAL_BADGE_SUCCESS,
  payload: numApproval,
});

export const loadApprovalBadgeFailure = (err: Error) => ({
  type: actionTypes.LOAD_APPROVAL_BADGE_FAILURE,
  err,
});

export const loadNotify = () => ({
  type: actionTypes.LOAD_NOTIFY,
});

export const loadNotifySuccess = (response: any) => ({
  type: actionTypes.LOAD_NOTIFY_SUCCESS,
  payload: response,
});

export const loadNotifyFailure = (err: Error) => ({
  type: actionTypes.LOAD_NOTIFY_FAILURE,
  err,
});
